export default __webpack_public_path__ + "static/media/quotes.b00c9e41.png";